import React from "react";

export function Loading() {
    return <h1>Loading</h1>
}